// test1470
(1470 && 0);
